<div class="carousel-wrapper">

  <!-- Flechas de navegación -->
  <div class="arrows" *ngIf="!isMobile && cards.length > cant">
    <button (click)="moveLeft()">
      <img class="arrow-carrousel" src="./assets/img/arrow-carrousel2-left.png" alt="Left Arrow">
    </button>

    <button (click)="moveRight()">
      <img class="arrow-carrousel" src="./assets/img/arrow-carrousel2-right.png" alt="Right Arrow">
    </button>
  </div>
  <!-- VISTA: CARRUSEL -->
  <div class="carousel" #carouselWrapper (scroll)="onMobileScroll($event)" [attr.id]="componentId">
    <div #carouselContainer class="carousel-container" 
        [ngStyle]="{ 
          'transform': isMobile ? 'none' : carouselTransform,
          'transition': isTransitioning && !isMobile ? 'transform 0.4s ease-in-out' : 'none'
        }" 
        (transitionend)="onTransitionEnd()">

      <!-- Se removió el [style.flex] inline de aquí -->
      <div *ngFor="let item of cards" class="carousel-cell">
        <div class="carrera-card">
          <img 
            (click)="openModal(item.position)" 
            *ngIf="item.type == 'Imagen'" 
            [src]="item.path" 
            [alt]="item.titulo || item.title" 
            class="card-bg-img"
            onerror="this.src='./assets/img/default.png'">

          <div (click)="openModal(item.position)" class="card-bg-img video-card" *ngIf="item.type == 'Video (YouTube)'">
            <img [src]="item.thumbnailUrl" alt="Video thumbnail" class="video-thumbnail" />

            <div class="play-button-overlay">
              <div *ngIf="item.type == 'Video (YouTube)'" class="play-icon"></div>
              <span *ngIf="item.type == 'Imagen'">Ver</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</div>